import React from "react";
import { Link } from "react-router-dom";
import { absUrl } from "../lib/api";

export default function ProductCard({ product }) {
  const { slug, name, price, compareAt, images, soldOut } = product;
  const hasSecond = images.length > 1;
  return (
    <Link to={`/product/${slug}`} className="group block">
      <div className="relative overflow-hidden bg-neutral-100 aspect-[3/4]">
        <img
          src={absUrl(images[0])}
          alt={name}
          loading="lazy"
          className={`h-full w-full object-cover img-zoom ${
            hasSecond ? "group-hover:opacity-0" : ""
          } transition-opacity duration-500`}
        />
        {hasSecond && (
          <img
            src={absUrl(images[1])}
            alt={`${name} alternate`}
            loading="lazy"
            className="absolute inset-0 h-full w-full object-cover opacity-0 group-hover:opacity-100 transition-opacity duration-500"
          />
        )}
        {soldOut && (
          <span className="absolute top-3 left-3 bg-white/95 text-black text-[10px] tracking-[0.2em] px-3 py-1">
            SOLD OUT
          </span>
        )}
        {compareAt && !soldOut && (
          <span className="absolute top-3 left-3 bg-black text-white text-[10px] tracking-[0.2em] px-3 py-1">
            SALE
          </span>
        )}
      </div>
      <div className="pt-3 text-center">
        <h3 className="text-sm tracking-wide text-neutral-900">{name}</h3>
        <div className="mt-1 flex items-center justify-center gap-2">
          {compareAt && (
            <span className="text-sm text-neutral-400 line-through">₪{compareAt.toFixed(2)}</span>
          )}
          <span className="text-sm text-neutral-700">₪{price.toFixed(2)}</span>
        </div>
      </div>
    </Link>
  );
}
